import axios from "axios";

const GetUserNotifications = (auth) => {
  return axios.get("notifications/", {
    headers: {
      "x-auth-token": auth,
    },
  });
};
const UpdateNotificationStatus = (auth, obj) => {
  return axios.put("notifications/status", obj, {
    headers: {
      "x-auth-token": auth,
    },
  });
};
export { GetUserNotifications, UpdateNotificationStatus };
